import { fetchDocumentMetadata } from './fetchDocumentMetadata';

export type CSRFToken = { headerName: string | null; token: string | null };

/**
 * Fetches csrf fields from the parent JSP
 */
export const fetchCsrf = (document: Document): CSRFToken => {
  const headerName = fetchDocumentMetadata(document, 'csrf-param');
  return {
    headerName: headerName ?? 'X-CSRF-TOKEN',
    token: fetchDocumentMetadata(document, 'csrf-token'),
  };
};
